import { Theme } from "@mui/material";
import { mix } from "polished";
import { ClaimTypes } from "../../shared/CaseModel.ts";

export function getBlendedColor(types: string[], theme: Theme): string {
  // claims with no type are rendered in grey
  if (types.length === 0) {
    return getClaimTypeChipStyle(ClaimTypes.Other, theme).backgroundColor;
  }

  let colorSoFar = getClaimTypeChipStyle(types[0], theme).backgroundColor;

  for (let typeIndex = 1; typeIndex < types.length; typeIndex++) {
    const currentColor = getClaimTypeChipStyle(
      types[typeIndex],
      theme
    ).backgroundColor;
    colorSoFar = mix(0.5, colorSoFar, currentColor);
  }

  return colorSoFar;
}

export const getClaimTypeChipStyle = (
  type: string,
  theme: Theme
): { backgroundColor: string; color: string } => {
  switch (type) {
    case ClaimTypes.ProfessionalNegligence:
      return {
        backgroundColor: theme.palette.warning.light,
        color: theme.palette.primary.contrastText,
      };
    case ClaimTypes.BreachOfContract:
      return {
        backgroundColor: theme.palette.data.negative.main,
        color: theme.palette.data.negative.contrastText,
      };
    case ClaimTypes.Fraud:
      return {
        backgroundColor: theme.palette.data.positive.main,
        color: theme.palette.data.positive.contrastText,
      };
    case ClaimTypes.PersonalInjury:
      return {
        backgroundColor: theme.palette.warning.main,
        color: theme.palette.warning.contrastText,
      };
    case ClaimTypes.Defamation:
      return {
        backgroundColor: theme.palette.secondary.main,
        color: theme.palette.secondary.contrastText,
      };
    case ClaimTypes.Property:
      return {
        backgroundColor: theme.palette.info.main,
        color: theme.palette.info.contrastText,
      };
    case ClaimTypes.Commercial:
      return {
        backgroundColor: theme.palette.data.positive.dark,
        color: theme.palette.data.positive.contrastText,
      };
    case ClaimTypes.MedicalNegligence:
      return { backgroundColor: "#00897b", color: theme.palette.common.white };
    case ClaimTypes.ContentiousTrustAndProbate:
      return { backgroundColor: "#6a1b9a", color: theme.palette.common.white };
    case ClaimTypes.Employment:
      return { backgroundColor: "#283593", color: theme.palette.common.white };
    case ClaimTypes.Insolvency:
      return { backgroundColor: "#795548", color: theme.palette.common.white };
    case ClaimTypes.Competition:
      return { backgroundColor: "#c2185b", color: theme.palette.common.white };
    case ClaimTypes.Insurance:
      return { backgroundColor: "#00838f", color: theme.palette.common.white };
    case ClaimTypes.IntellectualProperty:
      return { backgroundColor: "#4527a0", color: theme.palette.common.white };
    case ClaimTypes.GroupAction:
      return { backgroundColor: "#827717", color: theme.palette.common.white };
    case ClaimTypes.InternationalArbitration:
      return { backgroundColor: "#0097a7", color: theme.palette.common.white };
    case ClaimTypes.BankingAndFinancialServices:
      return { backgroundColor: "#ad1457", color: theme.palette.common.white };
    case ClaimTypes.Other:
      return {
        backgroundColor: theme.palette.grey[300],
        color: theme.palette.getContrastText(theme.palette.grey[300]),
      };
    default:
      return {
        backgroundColor: theme.palette.background.default,
        color: theme.palette.common.black,
      };
  }
};
